// import React, { useState } from "react";
// import { Stack, Box, IconButton, Typography, Button } from "@mui/material";
// import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
// import { useSwipeable } from "react-swipeable";
// import { IoSunny } from "react-icons/io5";
// import WatchFrame from "./svgImage/WatchFrame.png";
// import AM from "./svgImage/Am333.png";
// import Noon from "./svgImage/After2.png";
// import PM from "./Icon/AM3.png";
// // import AM from "./svgImage/Morning Icon22.png";
// // import Noon from "./svgImage/Afternoon Icon22.png";
// // import PM from "./svgImage/Night Icon22.png";
// import WatchFrame1 from "./svgImage/WatchFrame11.png";
// import PM6 from "./AM_PM_Img/06.png";
// import PM7 from "./AM_PM_Img/07.png";
// import PM8 from "./AM_PM_Img/08.png";
// import PM9 from "./AM_PM_Img/09.png";
// import PM10 from "./AM_PM_Img/10.png";
// import AM7 from "./AM_PM_Img/m7.png";
// import AM8 from "./AM_PM_Img/m8.png";
// import AM9 from "./AM_PM_Img/m9.png";
// import AM10 from "./AM_PM_Img/m10.png";
// import AM11 from "./AM_PM_Img/m11.png";
// import { useMediaQuery, useTheme } from "@mui/material";
// import { IoSunnyOutline } from "react-icons/io5";
// import { IoSunnySharp } from "react-icons/io5";
// import { FaMoon } from "react-icons/fa6";
// import M7 from "./svgImage/watch/7am (2).png";
// import M8 from "./svgImage/watch/8am (2).png";
// import M9 from "./svgImage/watch/9am (2).png";
// import M10 from "./svgImage/watch/10am (2).png";
// import M11 from "./svgImage/watch/11am (2).png";

// import A1 from "./svgImage/watch/12pm.png";
// import A2 from "./svgImage/watch/1pm.png";
// import A3 from "./svgImage/watch/2pm (2).png";
// import A4 from "./svgImage/watch/3pm (2).png";
// import A5 from "./svgImage/watch/4pm (2).png";

// import N6 from "./svgImage/watch/5PM (2).png";
// import N7 from "./svgImage/watch/6PM (2).png";
// import N8 from "./svgImage/watch/7PM (2).png";
// import N9 from "./svgImage/watch/8PM (2).png";
// import N10 from "./svgImage/watch/9PM (2).png";

// const FrameSection2 = ({ activeIndex, setActiveIndex, setPmData, pmData }) => {
//   // Inside your component
//   const theme = useTheme();
//   const isXl = useMediaQuery(theme.breakpoints.up("xl"));
//   const isLg = useMediaQuery(theme.breakpoints.between("lg", "xl"));
//   const isMd = useMediaQuery(theme.breakpoints.between("md", "lg"));
//   const isSm = useMediaQuery(theme.breakpoints.down("md"));

//   const getCardStyle = (index) => {
//     const length = accordions.length; // 5
//     const offset = (index - activeIndex + length) % length;

//     // Define styles based on breakpoints
//     if (isXl) {
//       switch (offset) {
//         case 0:
//           return {
//             transform: "translate(0, 0) scale(1)",
//             zIndex: 5,
//             opacity: 1,
//           };
//         case 1:
//           return {
//             transform: "translate(0, 84px) scale(0.9)",
//             zIndex: 4,
//             opacity: 0.4,
//           };
//         case 2:
//           return {
//             transform: "translate(0, 160px) scale(0.8)",
//             zIndex: 3,
//             opacity: 0.2,
//           };
//         case 4:
//           return {
//             transform: "translate(0, -84px) scale(0.9)",
//             zIndex: 2,
//             opacity: 0.4,
//           };
//         case 3:
//           return {
//             transform: "translate(0, -160px) scale(0.8)",
//             zIndex: 1,
//             opacity: 0.2,
//           };
//         default:
//           return {};
//       }
//     } else if (isLg) {
//       // Define styles for `lg` screens
//       switch (offset) {
//         case 0:
//           return {
//             transform: "translate(0, 0) scale(1)",
//             zIndex: 5,
//             opacity: 1,
//           };
//         case 1:
//           return {
//             transform: "translate(0, 88px) scale(0.9)",
//             zIndex: 4,
//             opacity: 0.4,
//           };
//         case 2:
//           return {
//             transform: "translate(0, 160px) scale(0.8)",
//             zIndex: 3,
//             opacity: 0.2,
//           };
//         case 4:
//           return {
//             transform: "translate(0, -88px) scale(0.9)",
//             zIndex: 2,
//             opacity: 0.4,
//           };
//         case 3:
//           return {
//             transform: "translate(0, -160px) scale(0.8)",
//             zIndex: 1,
//             opacity: 0.2,
//           };
//         default:
//           return {};
//       }
//     } else if (isMd) {
//       // Define styles for `md` screens
//       switch (offset) {
//         case 0:
//           return {
//             transform: "translate(0, 0) scale(1)",
//             zIndex: 5,
//             opacity: 1,
//           };
//         case 1:
//           return {
//             transform: "translate(0, 72px) scale(0.9)",
//             zIndex: 4,
//             opacity: 0.4,
//           };
//         case 2:
//           return {
//             transform: "translate(0, 136px) scale(0.8)",
//             zIndex: 3,
//             opacity: 0.2,
//           };
//         case 4:
//           return {
//             transform: "translate(0, -72px) scale(0.9)",
//             zIndex: 2,
//             opacity: 0.4,
//           };
//         case 3:
//           return {
//             transform: "translate(0, -136px) scale(0.8)",
//             zIndex: 1,
//             opacity: 0.2,
//           };
//         default:
//           return {};
//       }
//     } else if (isSm) {
//       // Define styles for `sm` screens
//       switch (offset) {
//         case 0:
//           return {
//             transform: "translate(0, 0) scale(1)",
//             zIndex: 5,
//             opacity: 1,
//           };
//         case 1:
//           return {
//             transform: "translate(0, 72px) scale(0.9)",
//             zIndex: 4,
//             opacity: 0.4,
//           };
//         case 2:
//           return {
//             transform: "translate(0, 138px) scale(0.8)",
//             zIndex: 3,
//             opacity: 0.2,
//           };
//         case 4:
//           return {
//             transform: "translate(0, -72px) scale(0.9)",
//             zIndex: 2,
//             opacity: 0.4,
//           };
//         case 3:
//           return {
//             transform: "translate(0, -138px) scale(0.8)",
//             zIndex: 1,
//             opacity: 0.2,
//           };
//         default:
//           return {};
//       }
//     }

//     return {}; // Default style
//   };

//   console.log("VerticalCardScroll:======>>>", pmData);

//   // For AM/PM toggling:
//   const accordions =
//     pmData === 1
//       ? [
//           { title: "PM 1", image: A1, backgroundColor: "#222222" },
//           { title: "PM 2", image: A2, backgroundColor: "#333333" },
//           { title: "PM 3", image: A3, backgroundColor: "#444444" },
//           { title: "PM 4", image: A4, backgroundColor: "#555555" },
//           { title: "PM 5", image: A5, backgroundColor: "#666666" },
//         ]
//       : pmData === 0
//       ? [
//           { title: "Card 1", image: M7, backgroundColor: "#FFB6C1" },
//           { title: "Card 2", image: M8, backgroundColor: "#ADD8E6" },
//           { title: "Card 3", image: M9, backgroundColor: "#90EE90" },
//           { title: "Card 4", image: M10, backgroundColor: "#FFD700" },
//           { title: "Card 5", image: M11, backgroundColor: "#FFA07A" },
//         ]
//       : [
//           { title: "Night 1", image: N6, backgroundColor: "#FFB6C1" },
//           { title: "Night 2", image: N7, backgroundColor: "#ADD8E6" },
//           { title: "Night 3", image: N8, backgroundColor: "#90EE90" },
//           { title: "Night 4", image: N9, backgroundColor: "#FFD700" },
//           { title: "Night 5", image: N10, backgroundColor: "#FFA07A" },
//         ];

//   // Swipe logic
//   const swipeHandlers = useSwipeable({
//     onSwipedUp: () => handleSwipe("UP"),
//     onSwipedDown: () => handleSwipe("DOWN"),
//   });

//   const handleSwipe = (direction) => {
//     if (direction === "UP") {
//       setActiveIndex((prev) => (prev + 1) % accordions.length);
//     } else {
//       setActiveIndex(
//         (prev) => (prev - 1 + accordions.length) % accordions.length
//       );
//     }
//   };

//   // When user clicks a card, bring it to the center
//   const handleCardClick = (index) => {
//     setActiveIndex(index);
//   };

//   const [selectedValue, setSelectedValue] = useState("morning");

//   // const getTranslateX = () => {
//   //   switch (selectedValue) {
//   //     case "morning":
//   //       return "0px";
//   //     case "business":
//   //       return "76px";
//   //     case "night":
//   //       return "148px"; // Move to Night
//   //     default:
//   //       return "0px";
//   //   }
//   // };

//   // Determine the highlight's position
//   const getTranslateX = () => {
//     switch (selectedValue) {
//       case "morning":
//         return "0%";
//       case "afternoon":
//         return "100%";
//       case "night":
//         return "200%";
//       default:
//         return "0%";
//     }
//   };

//   // Color is #3395DE for the selected label, #fff for the non‐selected
//   const getLabelColor = (value) => {
//     return selectedValue === value ? "#3395DE" : "black";
//   };

//   // Container style
//   // const containerStyle = {
//   //   display: "flex",
//   //   position: "relative",
//   //   width: { xl: "100%", lg: "100%", md: "100%", sm: "100%" }, // Total width of the container
//   //   height: "50px", // Height of the container
//   //   // border: "1px solid red",
//   //   borderRadius: "8px",
//   //   overflow: "hidden",
//   //   backgroundColor: "#f5f5f5",
//   //   boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//   //   marginRight: { xl: "0px", lg: "0px", md: "0px", sm: "0px" },
//   // };

//   // Container style
//   const containerStyle = {
//     display: "flex",
//     position: "relative",
//     width: { xl: "100%", lg: "100%", md: "100%", sm: "100%" }, 
//     height: "50px", 
//     borderRadius: "12px", 
//     overflow: "hidden",
//     backgroundColor: "rgba(255, 255, 255, 0.15)", 
//     backdropFilter: "blur(10px)", 
//     WebkitBackdropFilter: "blur(10px)", 
//     border: "1px solid rgba(255, 255, 255, 0.3)", 
//     boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)", 
//     marginRight: { xl: "0px", lg: "0px", md: "0px", sm: "0px" },
//   };
//   // Common style for both <input> radios
//   const inputStyle = {
//     display: "none",
//   };

//   // Common style for both <label> segments

//   const labelStyle = {
//     flex: 1,
//     textAlign: "center",
//     lineHeight: "50px", // Vertically centers the text
//     fontSize: "16px",
//     cursor: "pointer",
//     position: "relative",
//     zIndex: 2,
//     userSelect: "none",
//   };

//   // The highlight “slider” behind the active segment

//   const highlightStyle = {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "33.33%", // Divide the width equally for 3 buttons
//     height: "100%",
//     backgroundColor: "#fff",
//     // boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
//     transition: "transform 0.3s ease-in-out",
//     transform: `translateX(${getTranslateX()})`,
//     zIndex: 1,
//   };
//   return (
//     <>
//       <Stack
//         {...swipeHandlers}
//         sx={{
//           display: "flex",
//           justifyContent: "space-evenly",
//           alignItems: "center",
//           width: { xl: "100%", lg: "100%", md: "100%", sm: "100%" },
//           height: { xl: "100%", lg: "700px", md: "700px", sm: "700px" }, // Enough space to show all stacked
//           position: "relative",
//           overflow: "hidden",
//           flexDirection: "column",
//           //   padding: "16px",
//           // paddingLeft: { xl: "40px" },
//           // paddingRight: { xl: "40px" },
//           // border: "4px solid red",
//         }}
//       >
//         <Stack
//           alignItems="center"
//           justifyContent="center"
//           sx={{
//             // border: "2px solid blue",
//             width: { xl: "72%", lg: "100%", md: "100%", sm: "100%" },
//           }}
//         >
//           <Box sx={containerStyle}>
//             {/* Highlight */}
//             <Box sx={highlightStyle} />

//             {/* Morning */}
//             <Box
//               sx={{
//                 ...labelStyle,
//                 color: getLabelColor("morning"),
//                 position: "relative",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 // left: "8px",
//                 fontFamily:
//                   "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
//                 borderRight: "2px solid #e0e0e0",
//               }}
//               onClick={() => {
//                 setSelectedValue("morning");
//                 setPmData(0);
//               }}
//             >
//               {/* <IoSunnyOutline
//                 size={20}
//                 style={{ position: "relative", top: "2px", marginRight: "2px" }}
//               />{" "} */}
//               {/* Morning */}
//               <img
//                 src={AM}
//                 alt="topImg"
//                 style={{ height: "65%", width: "40%" }}
//               />
//             </Box>

//             {/* Afternoon */}
//             <Box
//               sx={{
//                 ...labelStyle,
//                 color: getLabelColor("afternoon"),
//                 fontFamily:
//                   "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 borderRight: "2px solid #e0e0e0",
//               }}
//               onClick={() => {
//                 setSelectedValue("afternoon");
//                 setPmData(1);
//               }}
//             >
//               {/* <IoSunnySharp
//                 size={20}
//                 style={{ position: "relative", top: "2px", marginRight: "8px" }}
//               /> */}
//               {/* Afternoon */}
//               <img
//                 src={Noon}
//                 alt="topImg"
//                 style={{ height: "65%", width: "40%" }}
//               />
//             </Box>

//             {/* Night */}
//             <Box
//               sx={{
//                 ...labelStyle,
//                 color: getLabelColor("night"),
//                 position: "relative",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 // right: "8px",
//                 fontFamily:
//                   "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
//               }}
//               onClick={() => {
//                 setSelectedValue("night");
//                 setPmData(2);
//               }}
//             >
//               {/* <FaMoon
//                 size={20}
//                 style={{ position: "relative", top: "2px", marginRight: "2px" }}
//               />{" "} */}
//               {/* Night */}
//               <img
//                 src={PM}
//                 alt="topImg"
//                 style={{ height: "60%", width: "40%" }}
//               />
//             </Box>
//           </Box>
//         </Stack>
//         <Box
//           sx={{
//             position: "relative",
//             width: { xl: "100%", lg: "100%", md: "100%", sm: "100%" },
//             height: "532px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             //  border: "1px solid red",
//           }}
//         >
//           {/* Cards */}
//           {accordions.map((card, index) => (
//             <Box
//               key={index}
//               onClick={() => handleCardClick(index)}
//               sx={{
//                 position: "absolute",
//                 width: "100%",
//                 height: { xl: "24%", lg: "20%", md: "20%", sm: "20%" },

//                 borderRadius: "8px",
//                 boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
//                 transition: "all 0.4s ease",
             
//                 //   activeIndex === index ? "1px solid black" : "1px solid black",
//                 display: "flex",
//                 // border: "4px solid red",
//                 flexDirection: "column",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 textAlign: "center",
//                 cursor: "pointer",
//                 // border: "1px solid red",
//                 width: { xl: "100%", lg: "100%", md: "100%", sm: "100%" },
//                 ...getCardStyle(index),
//               }}
//             >
//               <img
//                 src={card.image}
//                 alt="topImg"
//                 style={{ height: "100%", width: "100%" }}
//               />
//               {/* If this is the center card, show an overlay AND the watch frame */}
//               {activeIndex === index && (
//                 <>
//                   {/* Dim overlay */}

//                   {/* <Box
//                     component="img"
//                     src={WatchFrame1} // or your watch frame image
//                     alt="Watch Frame"
//                     sx={{
//                       position: "absolute",
//                       top: "50%",
//                       left: "50%",
//                       width: "100%",
//                       // width: { xl: "100%", lg: "100%", md: "100%", sm: "100%" },
//                       transform: "translate(-50%, -50%)",
//                       zIndex: 999,
//                       pointerEvents: "none",
//                       // border: "4px solid green",
//                     }}
//                   /> */}
//                 </>
//               )}
//             </Box>
//           ))}
//         </Box>
//       </Stack>
//     </>
//   );
// };

// export default FrameSection2;


import React, { useState } from "react";
import { Stack, Box, IconButton, Typography, Button } from "@mui/material";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import { useSwipeable } from "react-swipeable";
import { IoSunny } from "react-icons/io5";
import WatchFrame from "./svgImage/WatchFrame.png";
import AM from "./svgImage/Am333.png";
import Noon from "./svgImage/After2.png";
import PM from "./Icon/AM3.png";
// import AM from "./svgImage/Morning Icon22.png";
// import Noon from "./svgImage/Afternoon Icon22.png";
// import PM from "./svgImage/Night Icon22.png";
import WatchFrame1 from "./svgImage/WatchFrame11.png";
import PM6 from "./AM_PM_Img/06.png";
import PM7 from "./AM_PM_Img/07.png";
import PM8 from "./AM_PM_Img/08.png";
import PM9 from "./AM_PM_Img/09.png";
import PM10 from "./AM_PM_Img/10.png";
import AM7 from "./AM_PM_Img/m7.png";
import AM8 from "./AM_PM_Img/m8.png";
import AM9 from "./AM_PM_Img/m9.png";
import AM10 from "./AM_PM_Img/m10.png";
import AM11 from "./AM_PM_Img/m11.png";
import { useMediaQuery, useTheme } from "@mui/material";
import { IoSunnyOutline } from "react-icons/io5";
import { IoSunnySharp } from "react-icons/io5";
import { FaMoon } from "react-icons/fa6";
import M7 from "./svgImage/watch/7am (2).png";
import M8 from "./svgImage/watch/8am (2).png";
import M9 from "./svgImage/watch/9am (2).png";
import M10 from "./svgImage/watch/10am (2).png";
import M11 from "./svgImage/watch/11am (2).png";

import A1 from "./svgImage/watch/12pm.png";
import A2 from "./svgImage/watch/1pm.png";
import A3 from "./svgImage/watch/2pm (2).png";
import A4 from "./svgImage/watch/3pm (2).png";
import A5 from "./svgImage/watch/4pm (2).png";

import N6 from "./svgImage/watch/5PM (2).png";
import N7 from "./svgImage/watch/6PM (2).png";
import N8 from "./svgImage/watch/7PM (2).png";
import N9 from "./svgImage/watch/8PM (2).png";
import N10 from "./svgImage/watch/9PM (2).png";

const FrameSection2 = ({ activeIndex, setActiveIndex, setPmData, pmData }) => {
  // Inside your component
  const theme = useTheme();
  const isXl = useMediaQuery(theme.breakpoints.up("xl"));
  const isLg = useMediaQuery(theme.breakpoints.between("lg", "xl"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isSm = useMediaQuery(theme.breakpoints.down("md"));

  const getCardStyle = (index) => {
    const length = accordions.length; // 5
    const offset = (index - activeIndex + length) % length;

    // Define styles based on breakpoints
    if (isXl) {
      switch (offset) {
        case 0:
          return {
            transform: "translate(0, 0) scale(1)",
            zIndex: 5,
            opacity: 1,
          };
        case 1:
          return {
            transform: "translate(0, 84px) scale(0.9)",
            zIndex: 4,
            opacity: 0.4,
          };
        case 2:
          return {
            transform: "translate(0, 160px) scale(0.8)",
            zIndex: 3,
            opacity: 0.2,
          };
        case 4:
          return {
            transform: "translate(0, -84px) scale(0.9)",
            zIndex: 2,
            opacity: 0.4,
          };
        case 3:
          return {
            transform: "translate(0, -160px) scale(0.8)",
            zIndex: 1,
            opacity: 0.2,
          };
        default:
          return {};
      }
    } else if (isLg) {
      // Define styles for `lg` screens
      switch (offset) {
        case 0:
          return {
            transform: "translate(0, 0) scale(1)",
            zIndex: 5,
            opacity: 1,
          };
        case 1:
          return {
            transform: "translate(0, 88px) scale(0.9)",
            zIndex: 4,
            opacity: 0.4,
          };
        case 2:
          return {
            transform: "translate(0, 160px) scale(0.8)",
            zIndex: 3,
            opacity: 0.2,
          };
        case 4:
          return {
            transform: "translate(0, -88px) scale(0.9)",
            zIndex: 2,
            opacity: 0.4,
          };
        case 3:
          return {
            transform: "translate(0, -160px) scale(0.8)",
            zIndex: 1,
            opacity: 0.2,
          };
        default:
          return {};
      }
    } else if (isMd) {
      // Define styles for `md` screens
      switch (offset) {
        case 0:
          return {
            transform: "translate(0, 0) scale(1)",
            zIndex: 5,
            opacity: 1,
          };
        case 1:
          return {
            transform: "translate(0, 72px) scale(0.9)",
            zIndex: 4,
            opacity: 0.4,
          };
        case 2:
          return {
            transform: "translate(0, 136px) scale(0.8)",
            zIndex: 3,
            opacity: 0.2,
          };
        case 4:
          return {
            transform: "translate(0, -72px) scale(0.9)",
            zIndex: 2,
            opacity: 0.4,
          };
        case 3:
          return {
            transform: "translate(0, -136px) scale(0.8)",
            zIndex: 1,
            opacity: 0.2,
          };
        default:
          return {};
      }
    } else if (isSm) {
      // Define styles for `sm` screens
      switch (offset) {
        case 0:
          return {
            transform: "translate(0, 0) scale(1)",
            zIndex: 5,
            opacity: 1,
          };
        case 1:
          return {
            transform: "translate(0, 72px) scale(0.9)",
            zIndex: 4,
            opacity: 0.4,
          };
        case 2:
          return {
            transform: "translate(0, 138px) scale(0.8)",
            zIndex: 3,
            opacity: 0.2,
          };
        case 4:
          return {
            transform: "translate(0, -72px) scale(0.9)",
            zIndex: 2,
            opacity: 0.4,
          };
        case 3:
          return {
            transform: "translate(0, -138px) scale(0.8)",
            zIndex: 1,
            opacity: 0.2,
          };
        default:
          return {};
      }
    }

    return {}; // Default style
  };

  console.log("VerticalCardScroll:======>>>", pmData);

  // For AM/PM toggling:
  const accordions =
    pmData === 1
      ? [
          { title: "PM 1", image: A1, backgroundColor: "rgba(34, 34, 34, 0.15)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" },
          { title: "PM 2", image: A2, backgroundColor: "rgba(51, 51, 51, 0.15)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" },
          { title: "PM 3", image: A3, backgroundColor: "rgba(68, 68, 68, 0.15)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" },
          { title: "PM 4", image: A4, backgroundColor: "rgba(85, 85, 85, 0.15)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" },
          { title: "PM 5", image: A5, backgroundColor: "rgba(102, 102, 102, 0.15)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" },
        ]
      : pmData === 0
      ? [
          { title: "Card 1", image: M7, backgroundColor: "rgba(255, 182, 193, 0.15)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" },
          { title: "Card 2", image: M8, backgroundColor: "rgba(173, 216, 230, 0.15)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" },
          { title: "Card 3", image: M9, backgroundColor: "rgba(144, 238, 144, 0.15)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" },
          { title: "Card 4", image: M10, backgroundColor: "rgba(255, 215, 0, 0.15)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" },
          { title: "Card 5", image: M11, backgroundColor: "rgba(255, 160, 122, 0.15)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" },
        ]
      : [
          { title: "Night 1", image: N6, backgroundColor: "rgba(255, 182, 193, 0.15)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" },
          { title: "Night 2", image: N7, backgroundColor: "rgba(173, 216, 230, 0.15)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" },
          { title: "Night 3", image: N8, backgroundColor: "rgba(144, 238, 144, 0.15)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" },
          { title: "Night 4", image: N9, backgroundColor: "rgba(255, 215, 0, 0.15)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" },
          { title: "Night 5", image: N10, backgroundColor: "rgba(255, 160, 122, 0.15)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" },
        ];

  // Swipe logic
  const swipeHandlers = useSwipeable({
    onSwipedUp: () => handleSwipe("UP"),
    onSwipedDown: () => handleSwipe("DOWN"),
  });

  const handleSwipe = (direction) => {
    if (direction === "UP") {
      setActiveIndex((prev) => (prev + 1) % accordions.length);
    } else {
      setActiveIndex(
        (prev) => (prev - 1 + accordions.length) % accordions.length
      );
    }
  };

  // When user clicks a card, bring it to the center
  const handleCardClick = (index) => {
    setActiveIndex(index);
  };

  const [selectedValue, setSelectedValue] = useState("morning");

  // Determine the highlight's position
  const getTranslateX = () => {
    switch (selectedValue) {
      case "morning":
        return "0%";
      case "afternoon":
        return "100%";
      case "night":
        return "200%";
      default:
        return "0%";
    }
  };

  // Color is #3395DE for the selected label, #fff for the non‐selected
  const getLabelColor = (value) => {
    return selectedValue === value ? "#3395DE" : "black";
  };

  // Container style
  const containerStyle = {
    display: "flex",
    position: "relative",
    width: { xl: "100%", lg: "100%", md: "100%", sm: "100%" }, 
    height: "50px", 
    borderRadius: "12px", 
    overflow: "hidden",
    backgroundColor: "rgba(255, 255, 255, 0.15)", 
    backdropFilter: "blur(10px)", 
    WebkitBackdropFilter: "blur(10px)", 
    border: "1px solid rgba(255, 255, 255, 0.3)", 
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)", 
    marginRight: { xl: "0px", lg: "0px", md: "0px", sm: "0px" },
  };

  // Common style for both <input> radios
  const inputStyle = {
    display: "none",
  };

  // Common style for both <label> segments
  const labelStyle = {
    flex: 1,
    textAlign: "center",
    lineHeight: "50px", // Vertically centers the text
    fontSize: "16px",
    cursor: "pointer",
    position: "relative",
    zIndex: 2,
    userSelect: "none",
  };

  // The highlight “slider” behind the active segment
  const highlightStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "33.33%", // Divide the width equally for 3 buttons
    height: "100%",
    backgroundColor: "#fff",
    transition: "transform 0.3s ease-in-out",
    transform: `translateX(${getTranslateX()})`,
    zIndex: 1,
  };

  return (
    <>
      <Stack
        {...swipeHandlers}
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
          width: { xl: "100%", lg: "100%", md: "100%", sm: "100%" },
          height: { xl: "100%", lg: "700px", md: "700px", sm: "700px" }, // Enough space to show all stacked
          position: "relative",
          overflow: "hidden",
          flexDirection: "column",
        }}
      >
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            width: { xl: "72%", lg: "100%", md: "100%", sm: "100%" },
          }}
        >
          <Box sx={containerStyle}>
            {/* Highlight */}
            <Box sx={highlightStyle} />

            {/* Morning */}
            <Box
              sx={{
                ...labelStyle,
                color: getLabelColor("morning"),
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontFamily:
                  "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                borderRight: "2px solid #e0e0e0",
              }}
              onClick={() => {
                setSelectedValue("morning");
                setPmData(0);
              }}
            >
              <img
                src={AM}
                alt="topImg"
                style={{ height: "65%", width: "40%" }}
              />
            </Box>

            {/* Afternoon */}
            <Box
              sx={{
                ...labelStyle,
                color: getLabelColor("afternoon"),
                fontFamily:
                  "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRight: "2px solid #e0e0e0",
              }}
              onClick={() => {
                setSelectedValue("afternoon");
                setPmData(1);
              }}
            >
              <img
                src={Noon}
                alt="topImg"
                style={{ height: "65%", width: "40%" }}
              />
            </Box>

            {/* Night */}
            <Box
              sx={{
                ...labelStyle,
                color: getLabelColor("night"),
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontFamily:
                  "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
              }}
              onClick={() => {
                setSelectedValue("night");
                setPmData(2);
              }}
            >
              <img
                src={PM}
                alt="topImg"
                style={{ height: "60%", width: "40%" }}
              />
            </Box>
          </Box>
        </Stack>
        <Box
          sx={{
            position: "relative",
            width: { xl: "100%", lg: "100%", md: "100%", sm: "100%" },
            height: "532px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Cards */}
          {accordions.map((card, index) => (
            <Box
              key={index}
              onClick={() => handleCardClick(index)}
              sx={{
                position: "absolute",
                width: "100%",
                height: { xl: "24%", lg: "20%", md: "20%", sm: "20%" },
                borderRadius: "8px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                transition: "all 0.4s ease",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
                textAlign: "center",
                cursor: "pointer",
                width: { xl: "100%", lg: "100%", md: "100%", sm: "100%" },
                backgroundColor: card.backgroundColor,
                backdropFilter: card.backdropFilter,
                WebkitBackdropFilter: card.WebkitBackdropFilter,
                border: card.border,
                ...getCardStyle(index),
              }}
            >
              <img
                src={card.image}
                alt="topImg"
                style={{ height: "100%", width: "100%" }}
              />
              {/* If this is the center card, show an overlay AND the watch frame */}
              {activeIndex === index && (
                <>
                  {/* Dim overlay */}
                </>
              )}
            </Box>
          ))}
        </Box>
      </Stack>
    </>
  );
};

export default FrameSection2;